import { StatusDaEntregaOcorrencia, StatusDaOcorrencia } from './enum';
import { EtapaOcorrencia } from './etapa-ocorrencia';

export class Ocorrencia {
  id: number;
  data: Date;
  idCupom: string;
  idTipoOcorrencia: number;
  tipoOcorrencia: string;
  statusTipoOcorrencia: number;
  titulo: string;
  detalhamento: string;
  idFuncionario: number;
  funcionario: string;
  status: StatusDaOcorrencia;
  statusDescricao: string;
  dataStatus: Date;
  integrador: string;
  integradorCpfCnpj: string;
  integradorCidadeUf: string;
  cliente: string;
  ressalva: boolean;
  vendedor: string;
  valor: number;
  enviouReposicao: boolean;
  cartaDebito: boolean;
  idSetor: number;
  idIntegradorCriador: number;
  marcaEq: string;
  modQtdNSerie: string;
  nomeSolicitante: string;
  emailSolicitante: string;
  telefoneSolicitante: string;
  criador: number;
  numeroNotaFiscal: string;
  pedidoNNota: string;
  pedidoVFutura: string;
  possuiNotaGenerica: boolean;
  idEtapa: number;
  nomeEtapa: string;
  dataEtapa: Date;
  idTransportadora: number;
  nomeTransportadora: string;
  valorBonificacao: number;
  previsaoEntrega: Date;
  statusEntrega: StatusDaEntregaOcorrencia;
  tempoEstimadoEtapas: string;
}
